import styles from "./About.module.scss";

const About = () => {
  return (
    <div className={styles.wrapper}>
      <h2>About me</h2>
      <p className={styles.description}>
        Hi, I'm <b>Barnabas Olugbogi</b>, a React Developer and Data Analyst.{" "}
        <br /> <br /> I create sleek and interactive web applications while
        uncovering insights from data. <br /> <br />{" "}
        <b> As a React Developer, </b> I love crafting modern and responsive
        user interfaces using React. I love simplifying complex problems into
        elegant solutions, focusing on performance and user experience. <br />{" "}
        <br /> <b> As a Data Analyst,</b> I'm also passionate about data
        analysis. From cleaning and exploring data to building predictive
        models, I leverage tools like Python, SQL and Tableau to turn raw
        information into actionable insights. <br /> <br />
        <b>Why Both? </b>
        Combining React development with data analysis lets me create
        well-rounded solutions. I build visually appealing apps while using data
        to make informed decisions and drive business goals. <br /> <br /> I am
        also learning about Machine Learning, Natural Language Processing and AI
        to boost my expertise at predictions and problem solving. <br /> <br />
        Let's connect and bring your ideas to life!
      </p>
    </div>
  );
};

export default About;
